import { sift } from "./array";

export function arrayToPageTitle<T extends Array<unknown>>(arr: T): string {
  return sift(arr).join(" - ");
}
